import { defineComponent as _defineComponent } from 'vue'
import { BankingScheme, FeePaymentType } from 'ah-api-gateways';
import { computed, onMounted } from 'vue';
import { useBeneficiariesState } from 'ah-beneficiaries';


export default /*#__PURE__*/_defineComponent({
  __name: 'BankAccountRail',
  props: {
    currency: null,
    bankingScheme: { default: BankingScheme.LOCAL },
    type: null
  },
  setup(__props: any) {

const props = __props as { currency: string, bankingScheme: BankingScheme, type?: FeePaymentType };



const beneficiarieState = useBeneficiariesState();

onMounted(() => {
  beneficiarieState.store.useSettingsStore().loadPaymentRails();
});

const paymentRail = computed(() => {
  if (!props.bankingScheme) {
    return '-';
  }
  const out = beneficiarieState.store.useSettingsStore().getPaymentRail({
    currency: props.currency,
    bankingScheme: props.bankingScheme,
    type: props.type,
  });
  if (out.length > 0) {
    return out[0].label;
  }
  return props.bankingScheme;
});

return { __sfc: true,props, beneficiarieState, paymentRail }
}

})